import axios from "./config";

/**
 * @function
 * @name getPCTChallenges
 * @description get PCT challenges with optional sub_project_id, council_id and date range filtering
 *
 * */
const getPCTChallenges = (subProjectId = null, startDate = null, endDate = null, councilId = null) => {
  const params = {};
  
  if (subProjectId) {
    params['filter[sub_project_id]'] = subProjectId;
  }
  
  if (councilId) {
    params['filter[council_id]'] = councilId;
  }
  
  if (startDate) {
    params['filter[report_start_date]'] = new Date(startDate).toISOString();
  }
  
  if (endDate) {
    params['filter[report_end_date]'] = new Date(endDate).toISOString();
  }
  
  return axios.get(`/pct-challenges`, { params });
};

/**
 * @function
 * @name getPITChallenges
 * @description get PIT challenges with optional sub_project_id, council_id and date range filtering
 *
 * */
const getPITChallenges = (subProjectId = null, startDate = null, endDate = null, councilId = null) => {
  const params = {};
  if (subProjectId) {
    params['filter[sub_project_id]'] = subProjectId;
  }
  if (councilId) {
    params['filter[council_id]'] = councilId;
  }
  if (startDate) {
    params['filter[report_start_date]'] = new Date(startDate).toISOString().split('T')[0];
  }
  if (endDate) {
    params['filter[report_end_date]'] = new Date(endDate).toISOString().split('T')[0];
  }
  return axios.get(`/pit-challenges`, { params });
};

/**
 * @function
 * @name getCSCChallenges
 * @description get CSC challenges with optional sub_project_id, council_id and date range filtering
 *
 * */
const getCSCChallenges = (subProjectId = null, startDate = null, endDate = null, councilId = null) => {
  const params = {};
  
  if (subProjectId) {
    params['filter[sub_project_id]'] = subProjectId;
  }
  
  if (councilId) {
    params['filter[council_id]'] = councilId;
  }
  
  if (startDate) {
    params['filter[report_start_date]'] = new Date(startDate).toISOString().split('T')[0];
  }
  
  if (endDate) {
    params['filter[report_end_date]'] = new Date(endDate).toISOString().split('T')[0];
  }
  
  return axios.get(`/challenges`, { params });
};

/**
 * @function
 * @name getPCTReportVisitDates
 * @description get PCT report visit dates for a specific council
 *
 * */
const getPCTReportVisitDates = (councilId) => {
  const params = {};
  
  if (councilId) {
    params.council_id = councilId;
  }
  
  return axios.get(`/pct-reports/visit-dates`, { params });
};

/**
 * @function
 * @name getPITReportVisitDates
 * @description get PIT report visit dates for a specific council
 *
 * */
const getPITReportVisitDates = (councilId) => {
  const params = {};
  
  if (councilId) {
    params.council_id = councilId;
  }
  
  return axios.get(`/pit-reports/visit-dates`, { params });
};

export default {
  getPCTChallenges,
  getPITChallenges,
  getCSCChallenges,
  getPCTReportVisitDates,
  getPITReportVisitDates,
};